/** @jsx jsx */
import { useEffect } from "react";
import Button from "../Button";
import Input from "../Input";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { getStep1 } from "./machine";
import { State } from "xstate";
import { useMachine } from "@xstate/react";
import { jsx, css } from "@emotion/core";
import InputMask from "react-input-mask";
import { Flex, Box } from "rebass";
import StepContainer from "../StepContainer";

const errors = {
  email: {
    empty: "Email is a required field",
    badFormat: "Please enter a valid email"
  },
  confirmEmail: {
    mustMatch: "Email addresses must match"
  },
  firstName: {
    empty: "First name is a required field"
  },
  lastName: {
    empty: "Last name is a required field"
  },
  phoneNumber: {
    empty: "Phone number is a required field",
    badFormat: "Please enter a valid phone number"
  }
};

function getErrorMessage(
  item: string,
  current: State<any, any>
): string | undefined {
  const keys = Object.keys(errors[item]) || [];
  let message = undefined;

  keys.some(key => {
    if (current.matches(`ready.${item}.error.${key}`)) {
      message = errors[item][key];
    }
  });
  return message;
}
export default function({
  onSubmit,
  firstName,
  lastName,
  phoneNumber,
  email,
  confirmEmail
}: {
  onSubmit: (values: any) => void;
  firstName?: string;
  lastName?: string;
  phoneNumber?: number;
  email?: string;
  confirmEmail?: string;
}) {
  const [current, send] = useMachine(
    getStep1({ firstName, lastName, phoneNumber, email })
  );

  const finished = current.matches("finished");
  useEffect(() => {
    finished && onSubmit(current.context);
  }, [finished, current.context, onSubmit]);

  const handleChange: any = (type: string, property: string) => (
    e: React.FormEvent<HTMLInputElement>
  ) => {
    send({
      type,
      [property]: e.currentTarget ? e.currentTarget.value : ""
    });
  };

  const handleEmailChange = handleChange("INPUT_EMAIL", "email");
  const handleConfirmEmailChange = handleChange(
    "INPUT_CONFIRM_EMAIL",
    "confirmEmail"
  );
  const handleFirstNameChange = handleChange("INPUT_FIRST_NAME", "firstName");
  const handleLastNameChange = handleChange("INPUT_LAST_NAME", "lastName");
  const handlePhoneChange = handleChange("INPUT_PHONE", "phoneNumber");

  return (
    <StepContainer title="Step 1 / 5: Contact Information">
      <Input
        required
        error={current.matches("ready.firstName.error")}
        label="First Name"
        name="firstName"
        value={firstName}
        onChange={handleFirstNameChange}
        helperText={getErrorMessage("firstName", current)}
        css={css`
          margin-bottom: 20px;
        `}
      />
      <Input
        required
        error={current.matches("ready.lastName.error")}
        label="Last Name"
        name="lastName"
        value={lastName}
        helperText={getErrorMessage("lastName", current)}
        onChange={handleLastNameChange}
        css={css`
          margin-bottom: 20px;
        `}
      />
      <Input
        required
        type="email"
        error={current.matches("ready.email.error")}
        label="Email"
        name="email"
        value={email}
        helperText={getErrorMessage("email", current)}
        onChange={handleEmailChange}
        css={css`
          margin-bottom: 20px;
        `}
      />
      <Input
        required
        type="email"
        error={current.matches("ready.confirmEmail.error")}
        helperText={getErrorMessage("confirmEmail", current)}
        label="Confirm Email"
        name="confirmEmail"
        value={confirmEmail}
        onChange={handleConfirmEmailChange}
        css={css`
          margin-bottom: 20px;
        `}
      />

      <InputMask
        mask="(999)999-9999"
        value={phoneNumber}
        onChange={handlePhoneChange}
      >
        {inputProps => (
          <Input
            required
            type="tel"
            {...inputProps}
            error={current.matches("ready.phoneNumber.error")}
            label="Phone Number"
            name="phoneNumber"
            helperText={getErrorMessage("phoneNumber", current)}
            css={css`
              margin-bottom: 20px;
            `}
          />
        )}
      </InputMask>

      <Flex justifyContent="flex-end">
        <Button
          onClick={() => {
            send("SUBMIT");
          }}
          width={200}
        >
          Continue
        </Button>
      </Flex>
    </StepContainer>
  );

  return <div>Hello</div>;
}
